import React from 'react';
import immutable from 'immutable';
import ReactDOM from 'react-dom';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import NavigationCheck from 'material-ui/svg-icons/navigation/check';
import Popover from 'material-ui/Popover';
import * as Colors from 'material-ui/styles/colors';

import Theme from 'styles/theme';
import 'styles/SavedSearchWidget.styl';

import DeleteIcon from 'images/common/DeleteRemove.svg';
import {getMuiV4Theme} from 'utils/css/themeUtils';

const actionButtonStyle = immutable.Map({
  display: 'inline',
  height: '100%',
  minWidth: 'initial',
});

const actionButtonLabelStyle = {
  color: Theme.palette.actionButtonLabelColor,
  fontSize: '16px',
  padding: '0px',
  textTransform: 'none',
};

/**
 * SavedSearchActionButtons renders two flat buttons side-by-side that allows
 * a user to save the current search or clear all the search filters
 */
class SavedSearchActionButtons extends React.Component {
  constructor() {
    super();
    this.state = {
      openPopover: false,
      savedSearchButton: null,
    };
  }

  onPopoverRequestClose = () => {
    this.setState({
      openPopover: false,
    });
  };

  onTouchTapClosePopoverButton = () => {
    this.setState({
      openPopover: false,
    });
  };

  /** Open the saved search popover */
  onTouchTapSaveSearchPopover = () => {
    this.setState({
      openPopover: true,
    });
  };

  onTouchTapSaveSearchButton = () => {
    if (this._savedSearchTitleTextArea.value.length > 0) {
      this.props.onTouchTapSaveSearchButton(this._savedSearchTitleTextArea.value);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.openPopover !== nextProps.openPopover) {
      this.setState({
        openPopover: nextProps.openPopover,
      });
    }
  }

  componentDidMount() {
    this.setState({
      savedSearchButton: ReactDOM.findDOMNode(this._savedSearchButton),
    });
  }

  componentDidUpdate() {
    // handle popover opening up
    if (this.state.openPopover) {
      // focus text input
      if (this._savedSearchTitleTextArea) {
        this._savedSearchTitleTextArea.focus();
      }
    }
  }

  render() {
    return (
      <div className="sidebar-action-box">
        <FlatButton
          label="Save Search"
          labelStyle={actionButtonLabelStyle}
          style={actionButtonStyle.toObject()}
          hoverColor="initial"
          className="saved-search-widget-action-button"
          onClick={this.onTouchTapSaveSearchPopover}
          ref={c => (this._savedSearchButton = c)}>
          <Popover
            open={this.state.openPopover}
            anchorEl={this.state.savedSearchButton}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}
            className={`saved-button-popover`}
            onRequestClose={this.onPopoverRequestClose}>
            <div className="popover-container">
              <div className="input-column">
                <input
                  className="input-field"
                  placeholder="My saved search"
                  ref={c => (this._savedSearchTitleTextArea = c)}
                />
              </div>
              <div className="buttons-column">
                <IconButton
                  onClick={this.onTouchTapSaveSearchButton}
                  style={{backgroundColor: getMuiV4Theme().palette.primary.main}}>
                  <NavigationCheck color={Colors.grey50} />
                </IconButton>
                <IconButton onClick={this.onTouchTapClosePopoverButton}>
                  <img alt="unknown" src={DeleteIcon} />
                </IconButton>
              </div>
            </div>
          </Popover>
        </FlatButton>
      </div>
    );
  }
}

export default SavedSearchActionButtons;
